import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const REVERT_AUCTION_BET = 'AUCTION :: REVERT_AUCTION_BET';

export type TRevertAuctionBetAction = IReduxAction<typeof REVERT_AUCTION_BET>;

export const revertAuctionBet = actionGenerator<typeof REVERT_AUCTION_BET>(REVERT_AUCTION_BET);
